var ScrollSync = /** @class */ (function () {
    function ScrollSync(source, targets, options) {
        source.addEventListener('scroll', this.onScroll.bind(this, source, targets, options));
    }
    ScrollSync.prototype.onScroll = function (source, targets, options) {
        targets.forEach(function (target) {
            if (options.syncHorizontal && target)
                target.scrollLeft = source.scrollLeft;
            if (options.syncVertical && target)
                target.scrollTop = source.scrollTop;
        });
    };
    return ScrollSync;
}());
export { ScrollSync };
